<template>
    <div class="form-container">
      <h2>Claim a Coupon</h2>

      <div class="form-row mt-4">
        <label class="label required">Coupon Code</label>
        <div class="value">
          <input
            v-model="code"
            class="select"
            type="text"
          >
        </div>
      </div>
      <div class="form-row mt-3 form-footer">
        <button class="button button-sm rounded" :disabled="!code" @click="apply()">Claim</button>
      </div>
    </div>

</template>

<script>
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useToast } from 'vue-toast-notification';
import { event } from 'vue-gtag';

const $toast = useToast();
export default {
  name: 'ClaimCoupon',
  components: {
  },
  data() {
    return {
      dsConn: new DatastoreConnect(this.$store.state.enterpriseServerUrl),
      code: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    isAdmin() {
      return this.user && (this.user.role === 'admin');
    },
    isSuper() {
      return this.user && (this.user.role === 'super');
    },
  },
  async created() {
    if (!this.isAdmin && !this.isSuper) {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    async apply() {
      if (!this.code) {
        event('claim_coupon_failure', {
          category: 'claim_coupon',
          label: 'User failed to claim a coupon',
          user: this.user.username,
          reason: 'Missing coupon code',
        });
        $toast.open({
          queue: true,
          duration: 5000,
          message: `Missing coupon code`,
          type: "error",
          position: "top",
        });
        return;
      }
      const params = {
        code: this.code,
      };
      await this.dsConn.useCoupons(params)
        .then((data) => {
          if (data.result) {
            event('claim_coupon_success', {
              category: 'claim_coupon',
              label: 'User successfully claimed a coupon',
              user: this.user.username,
            });
            $toast.open({
              queue: true,
              duration: 5000,
              message: `Coupon claimed successfully!`,
              type: "success",
              position: "top",
            });
          } else {
            event('claim_coupon_failure', {
              category: 'claim_coupon',
              label: 'User failed to claim a coupon',
              user: this.user.username,
              reason: data.error.message,
            });
            $toast.open({
              queue: true,
              duration: 5000,
              message: `${data.error.message}`,
              type: "error",
              position: "top",
            });
          }
        })
        .catch((e) => {
          event('claim_coupon_failure', {
            category: 'claim_coupon',
            label: 'User failed to claim a coupon',
            user: this.user.username,
            reason: 'Unknown Error',
          });
          $toast.open({
            queue: true,
            duration: 5000,
            message: `${e}`,
            type: "error",
            position: "top",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
